import { render } from "./SiteAuthTextsCard.vue?vue&type=template&id=279b5ae4"
import script from "./SiteAuthTextsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteAuthTextsCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Sites/SiteAuthTextsCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "279b5ae4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('279b5ae4', __exports__)) {
    api.reload('279b5ae4', __exports__)
  }
  
  module.hot.accept("./SiteAuthTextsCard.vue?vue&type=template&id=279b5ae4", () => {
    api.rerender('279b5ae4', render)
  })

}


export default __exports__